import { render } from "./Notification-Card.vue?vue&type=template&id=d7008262&ts=true"
import script from "./Notification-Card.vue?vue&type=script&lang=ts"
export * from "./Notification-Card.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__